export const DEPOSIT_WITHDRAW_MAX_DECIMAL_PLACES = 2;
